import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-home-report',
  imports: [TranslatePipe],
  templateUrl: './home-report.html',
  styleUrl: './home-report.scss',
})
export class HomeReport {}
